import * as types from '@/store/mutation-types';

export default {
    namespaced: true,
    state: {
        deliveryStatus: []
    },
    actions: {
        fetchAll({ commit }){
            return window.axios.get('/DeliveryStatus').then(response => {
                commit(types.STORE_DELIVERY_STATUS, response.data)
                return response.data
            })
        },

        create(_, {
			name,
            invoiceType,
            isFinalStatus
		}) {
			return window.axios.post('/DeliveryStatus', {
				name: name,
                invoice_type: invoiceType,
                is_final_status: isFinalStatus
			}) .then(response => {
                return response.data;
            });
		},

        update(_, { 
            deliveryStatusId,
            name,
            invoiceType,
            isFinalStatus
        }) {
            return window.axios.put(`/DeliveryStatus/${deliveryStatusId}`, {
                name: name,
                invoice_type: invoiceType,
                is_final_status: isFinalStatus
            })
        },

        delete(_, { deliveryStatusId }) {
			return window.axios.delete(`/DeliveryStatus/${deliveryStatusId}`)
		},
    },

    getters: {
        getDeliveryStatusById: state => id => state.deliveryStatus.find(c => c.id === id)
    },

    mutations: {
        [types.STORE_DELIVERY_STATUS](state, deliveryStatus) { 
            state.deliveryStatus = deliveryStatus; 
        }
    }
}
